<template>
    <div id="edit-profile-group-page">
        <div class="top-buttons">
            <ui5-button @click="save">{{ trans('pages.edit_profile_group.save') }}</ui5-button>
            <ui5-button @click="$router.push('/settingsProfile')">
                {{ trans('pages.edit_profile_group.cancel') }}
            </ui5-button>
        </div>
        <div class="fields" v-if="group">
            <ui5-label required>{{ trans('pages.edit_profile_group.key_label') }}</ui5-label>
            <ui5-input
                :readonly="!isNew"
                type="Text"
                :value="group.name"
                @input="group.name = $event.target.value" />
            <translations-edit
                v-if="!isNew"
                :translation-data="group.translations.name"></translations-edit>
        </div>
    </div>
</template>
<script>
import TranslationsEdit from '../components/TranslationsEdit';
import profileApi from '../api/profile';
import languageApi from '../api/language';
import ErrorHelper from '../helpers/ErrorHelper';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { TranslationsEdit },
    mixins: [localization],
    data() {
        return {
            level: null,
            group: null,
            languages: null,
        };
    },
    computed: {
        isNew() {
            return this.$router.history.current.path.startsWith(
                '/addProfileGroup'
            );
        },
    },
    methods: {
        save() {
            if (!this.isNew) {
                const payload = {
                    profileGroupId: this.group.profileGroupId,
                    name: {
                        value: this.group.name,
                        translations: this.group.translations.name,
                    },
                };

                profileApi
                    .updateGroup(payload)
                    .then(() => {
                        showInfoMessage(this.trans('pages.edit_profile_group.group_updated'), () => {
                            this.$router.push('/settingsProfile');
                        });
                    })
                    .catch((error) => {
                        if (error.response.data) {
                            showErrorMessage(
                                ErrorHelper.parseError(error.response.data)
                            );
                        } else {
                            showErrorMessage(
                                this.trans('pages.edit_profile_group.group_update_error')
                            );
                        }
                    });
            } else {
                const payload = {
                    name: this.group.name,
                    level: this.level,
                };

                profileApi
                    .insertGroup(payload)
                    .then(() => {
                        showInfoMessage(this.trans('pages.edit_profile_group.group_added'), () => {
                            this.$router.push('/settingsProfile');
                        });
                    })
                    .catch((error) => {
                        if (error.response.data) {
                            showErrorMessage(
                                ErrorHelper.parseError(error.response.data)
                            );
                        } else {
                            showErrorMessage(
                                this.trans('pages.edit_profile_group.group_add_error')
                            );
                        }
                    });
            }
        },
    },
    mounted() {
        if (!this.isNew) {
            const groupId = this.$route.params.id;
            profileApi
                .fetchGroup(groupId)
                .then((response) => {
                    this.group = response.data.data;
                })
                .catch((error) => {
                    showErrorMessage(error.responseText);
                });
        } else {
            languageApi.fetchAll().then((request) => {
                this.languages = request.data.data;

                const translations = {};
                this.languages.forEach((x) => {
                    translations[x.code] = '';
                });

                this.level = this.$route.params.level;
                this.group = {
                    name: null,
                    translations: {
                        name: translations,
                    },
                };
            });
        }
    },
};
</script>
